import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, Component, createRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
  Badge,
  Spinner,
} from "reactstrap";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import TablePenilaianBawahanComponent from "./Components/TablePenilaianBawahanComponent";
import TablePenilaianDiriSendiriComponent from "./Components/TablePenilaianDiriSendiriComponent";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { AvForm } from "availity-reactstrap-validation";
// import CreateBloc from "../Create/Blocs/CreateBloc";
import apiResponse from "../../../../services/apiResponse";
import DataTableBloc from "./Blocs/DataTableBloc";
import CreateBloc from "../Create/Blocs/CreateBloc";
import moment from "moment";
import Shimmer from "react-shimmer-effect";

var reformatWorkUnit = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.work_unit_name_full;
    newObj["value"] = data.work_unit_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

var reformatAtasan = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    if (data.position_name != "Semua Data") {
      newObj["label"] = data.employee_name + " (" + data.position_name + ")";
    } else {
      newObj["label"] = data.position_name;
    }
    newObj["value"] = data.position_uuid;
    // newObj["value"] = data.employee_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

class IndexView extends Component {
  source;
  historyMonth = "penilaian_history_month_tunsus"; //
  historyYear = "penilaian_history_year_tunsus"; //
  defaultOrder = "special_allowance_summary_id"; // orderBy
  userdata = JSON.parse(localStorage.getItem("userdata"));

  role = localStorage.getItem("currentRoleId");
  createBloc = new CreateBloc();
  dataTableBloc = new DataTableBloc();

  constructor(props) {
    super(props);
    const is_eselon = this.getEselon();
    this.state = {
      loadingTableAtasan: true,
      loadingDetail: true,
      is_eselon: is_eselon,
      confirmInfo: "Apakah anda yakin akan menyimpan data ini?",
      dataForm: {},
      monthOptions: this.createMonthOptions(),
      yearOptions: this.createYearOption(new Date().getFullYear() - 30),
      hirarkiOptions: [],
      workUnitOptions: [],
      atasanOptions: [],
      totalEselon: 0,

      // periode pembayaran
      month: localStorage.getItem(this.historyMonth)
        ? JSON.parse(localStorage.getItem(this.historyMonth))
        : moment().format("M"),
      year: localStorage.getItem(this.historyYear)
        ? JSON.parse(localStorage.getItem(this.historyYear))
        : moment().format("YYYY"),

      // periode penialaian
      monthPenilaian: localStorage.getItem(this.historyMonth)
        ? this.monthPenilaian(
            JSON.parse(localStorage.getItem(this.historyMonth), 1)
          )
        : this.monthPenilaian(moment().format("M"), 1),
      yearPenilaian: localStorage.getItem(this.historyMonth)
        ? this.yearPenilaian(
            JSON.parse(localStorage.getItem(this.historyMonth)),
            1
          )
        : this.yearPenilaian(moment().format("M"), 1),

      // periode presensi
      monthPresensi: localStorage.getItem(this.historyMonth)
        ? this.monthPenilaian(
            JSON.parse(localStorage.getItem(this.historyMonth), 2)
          )
        : this.monthPenilaian(moment().format("M"), 1),
      yearPresensi: localStorage.getItem(this.historyMonth)
        ? this.yearPenilaian(
            JSON.parse(localStorage.getItem(this.historyMonth)),
            2
          )
        : this.yearPenilaian(moment().format("M"), 1),
      day: moment().format("d"),
      currentMonth: moment().format("M"),
      currentYear: moment().format("YYYY"),
      currentDay: parseInt(moment().format("D")),

      hirarkiSelected: "",
      roleId: localStorage.getItem("currentRoleId"),
      atasanSelected: this.getEmployee(is_eselon),
      positionSelected: "",
      positionSelectedSend: "",
      workUnitSelected: "",
      generate_verification_status: 1, //0
      showUpload: false,
      document: null,
      activeTab: "1",
      configValue: 0,
      configPenilaian: 0,
      originalconfigPenilaian: 0,
      configNotif: "",
      presensi: 0,
      skp: 0,
      penilaian: 0,
      monthFilter: moment().format("M"),
      yearFilter: moment().format("YYYY"),
      configStartDateEselon: null,
      configEndDateEselon: null,
      configStartDateAdmin: null,
      configEndDateAdmin: null,
      statusVerifikasi: 0,
      employee_uuids: [],
      position_uuids: [],
    };
    this.activeRef = createRef();
    this.secondRef = createRef();
  }
  createMonthOptions() {
    var months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return months.map(function (month, i) {
      var newObj = {};
      newObj["label"] = month;
      newObj["value"] = ++i;

      return newObj;
    });
  }

  formatDate = (value) => {
    if (value != "-") {
      let date = new Date(value);
      const day = date.toLocaleString("id-ID", { day: "2-digit" });
      const month = date.toLocaleString("id-ID", { month: "short" });
      const year = date.toLocaleString("id-ID", { year: "numeric" });
      return day + " " + month + " " + year;
    } else {
      return value;
    }
  };

  getMonthName(monthNumber) {
    const monthNamesId = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    // Ensure the monthNumber is within a valid range (1-12)
    if (monthNumber >= 1 && monthNumber <= 12) {
      return monthNamesId[monthNumber - 1]; // Adjusting for 0-based array indexing
    } else {
      return "Invalid Month";
    }
  }

  createYearOption(startYear = 2000) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
      var newObj = {};
      var year = startYear++;
      newObj["label"] = year;
      newObj["value"] = year;
      years.push(newObj);
    }
    return years;
  }

  monthPenilaian(month, type) {
    // 1 penilaian ,
    if (type == 1) {
      if (month == 1) {
        return 11;
      } else if (month == 2) {
        return 12;
      } else {
        return month - 2;
      }
    }

    // 2 presensi
    if (type == 2) {
      if (month == 1) {
        return 12;
      } else {
        return month - 1;
      }
    }
  }

  yearPenilaian(month, type) {
    // 1 penilaian ,
    if (type == 1) {
      if (month == 1) {
        return localStorage.getItem(this.historyYear)
          ? JSON.parse(localStorage.getItem(this.historyYear)) - 1
          : moment().format("YYYY") - 1;
      } else if (month == 2) {
        return localStorage.getItem(this.historyYear)
          ? JSON.parse(localStorage.getItem(this.historyYear)) - 1
          : moment().format("YYYY") - 1;
      } else {
        return localStorage.getItem(this.historyYear)
          ? JSON.parse(localStorage.getItem(this.historyYear))
          : moment().format("YYYY");
      }
    }
    // 2 presensi
    if (type == 2) {
      if (month == 1) {
        return localStorage.getItem(this.historyYear)
          ? JSON.parse(localStorage.getItem(this.historyYear)) - 1
          : moment().format("YYYY") - 1;
      } else {
        return localStorage.getItem(this.historyYear)
          ? JSON.parse(localStorage.getItem(this.historyYear))
          : moment().format("YYYY");
      }
    }
  }

  handleperiodePenilaian(month, year) {
    var bulan = month; // Januari
    var tahun = year;
    // penilaian
    let bulanSebelumnya = bulan;
    let tahunSebelumnya = tahun;

    // presensi
    let bulanPresensi = bulan;
    let tahunPresensi = tahun;

    if (bulan == 1) {
      bulanPresensi = 12;
      tahunPresensi--;
    } else {
      bulanPresensi = bulan - 1;
    }

    if (bulan == 1) {
      bulanSebelumnya = 11;
      tahunSebelumnya--;
    } else if (bulan == 2) {
      bulanSebelumnya = 12;
      tahunSebelumnya--;
    } else {
      bulanSebelumnya = bulan - 2;
    }
    this.setState({
      monthPenilaian: bulanSebelumnya,
      yearPenilaian: tahunSebelumnya,
      monthPresensi: bulanPresensi,
      yearPresensi: tahunPresensi,
    });
  }

  getMaxDaysInMonth(month, year) {
    const date = new Date(year, month - 1, 1);
    date.setMonth(date.getMonth() + 1);
    date.setDate(date.getDate() - 1);
    return date.getDate();
  }

  handleConfigChange = (newConfig, newOriginalConfig, newConfigNotif) => {
    this.setState({
      configPenilaian: newConfig,
      originalconfigPenilaian: newOriginalConfig,
      configNotif: newConfigNotif,
    });
  };

  checkCurrentMonth = () => {
    if (this.state.roleId == 2 && this.state.is_eselon == 1) {
      return parseInt(this.state.currentYear) ==
        parseInt(this.state.yearPresensi) &&
        parseInt(this.state.currentMonth) ==
          parseInt(this.state.monthPresensi) &&
        this.state.currentDay >= this.state.configStartDateEselon &&
        this.state.currentDay <= this.state.configEndDateEselon
        ? 1
        : 0;
    }
    // administrator
    else if (this.state.roleId == 1) {
      return parseInt(this.state.currentYear) ==
        parseInt(this.state.yearPresensi) &&
        parseInt(this.state.currentMonth) ==
          parseInt(this.state.monthPresensi) &&
        this.state.currentDay >= this.state.configStartDateAdmin &&
        this.state.currentDay <= this.state.configEndDateAdmin
        ? 1
        : 0;
    }
    // pegawai non eseleon
    else {
      return 0;
    }
  };

  getEselon() {
    const is_eselon_local = JSON.parse(
      localStorage.getItem("currentEchelonCode")
    );

    const is_ec =
      is_eselon_local &&
      typeof is_eselon_local === "string" &&
      (is_eselon_local.startsWith("1") || is_eselon_local.startsWith("2"))
        ? 1
        : typeof this.userdata.echelon_code === "string" &&
          (this.userdata.echelon_code.startsWith("1") ||
            this.userdata.echelon_code.startsWith("2"))
        ? 1
        : 0;
    // console.log(is_eselon_local);
    // console.log(is_ec);
    return is_ec;
  }
  // localStorage.getItem("echelon_code")
  //     ? typeof localStorage.getItem("echelon_code") === "string" &&
  //         (localStorage.getItem("echelon_code").startsWith("1") ||
  //           localStorage.getItem("echelon_code").startsWith("2"))
  //     :

  getEmployee(is_eselon) {
    const current_employee_uuid = JSON.parse(
      localStorage.getItem("currentEmployeeUuid")
    );
    return (this.role == 2 && is_eselon == 1) ||
      (this.role == 2 && is_eselon == 0)
      ? this.userdata.employee_uuid
      : this.role == 1 && current_employee_uuid
      ? current_employee_uuid
      : "";
  }

  getPosition() {
    // console.log(this.role)
    const position_local = JSON.parse(
      localStorage.getItem("currentPositionUuid")
    );
    var posisi_send = "";
    if (this.role == 1) {
      this.setState({
        positionSelectedSend:
          position_local && position_local != "Semua Data"
            ? position_local
            : "",
        positionSelected: position_local ? position_local : "Semua Data",
      });
      posisi_send = position_local ? position_local : "";
    }
    if (this.role == 2) {
      posisi_send = position_local
        ? position_local
        : this.userdata.employee_current_position_uuid;
    }

    this.setState({
      positionSelectedSend: posisi_send,
    });

    // console.log('posisi : ' + posisi_send);

    return posisi_send;
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        special_allowance_summary_month: this.state.month,
        special_allowance_summary_year: this.state.year,
      },
      confirm: true,
    });
  };
  submitData = async () => {
    await this.createBloc.fetchCreate(
      this.convertToFormData(this.state.dataForm)
    );
  };
  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }
    return formData;
  }

  handleGenerateUlang() {
    this.dataTableBloc.fetchRegenerate({
      year: this.state.year,
      month: this.state.month,
    });
  }

  handleButtonVerifikasi() {
    this.dataTableBloc.fetchVerifikasi({
      year: this.state.year,
      month: this.state.month,
    });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
    if (tab == 1) {
    } else if (tab == 2) {
    } else if (tab == 3) {
    }
  }

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };

        if (this.state.runType == 1) {
          this.submitData();
        }

        if (this.state.runType == 2) {
          this.handleGenerateUlang();
        }

        if (this.state.runType == 3) {
          this.handleButtonVerifikasi();
        }

        if (this.state.runType == 4) {
          this.handleSendNotification();
        }

        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
          showUpload: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  handleButtonReset() {
    this.setState({
      positionSelected: "Semua Data",
    });
    localStorage.setItem("currentEchelonCode", JSON.stringify(""));
    localStorage.setItem("currentPositionUuid", JSON.stringify("Semua Data"));
    localStorage.setItem("currentPositionName", JSON.stringify("Semua Data"));
    localStorage.setItem("currentEmployeeUuid", JSON.stringify(""));
    setTimeout(() => {
      // window.location.reload();
      this.listAtasan();
    }, 500);
  }

  handleSendNotification = async () => {
    const query = {
      year: this.state.year,
      month: this.state.month,
    };
    await this.dataTableBloc.sendNotification(query);
  };

  handleButtonExport() {
    this.activeRef.current.handleButtonExport();
  }

  detailBobot = async () => {
    const query = {
      year: this.state.year,
      month: this.state.month,
    };
    await this.dataTableBloc.fetchBobot(query);
  };

  listAtasan = async () => {
    this.setState({
      is_eselon: this.getEselon(),
      positionSelected: this.getPosition(),
    });
    // if (this.state.is_eselon == 1 || this.state.roleId == 1) {
    // if (this.state.roleId == 1) {
    this.dataTableBloc.fetchAtasan({
      year: this.state.year,
      month: this.state.month,
      roleId: this.state.roleId,
      is_echelon: this.state.is_eselon,
    });
    // }
  };

  componentDidMount() {
    // set default month penilaian

    this.handleperiodePenilaian(this.state.month, this.state.year);

    this.dataTableBloc.detailBobotChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            loadingDetail: false,
            presensi: response.presensi ? response.presensi : 0,
            skp: response.skp ? response.skp : 0,
            penilaian: response.penilaian ? response.penilaian : 0,
            yearFilter: response.year,
            monthFilter: response.month,
            configValue: response.config ? response.config.config_value : 1,
            configStartDateEselon: response.config_eselon
              ? response.config_eselon.special_allowance_period_start_date
              : null,
            configEndDateEselon: response.config_eselon
              ? response.config_eselon.special_allowance_period_end_date
              : null,
            configStartDateAdmin: response.config_admin
              ? response.config_admin.special_allowance_period_start_date
              : null,
            configEndDateAdmin: response.config_admin
              ? response.config_admin.special_allowance_period_end_date
              : null,
            statusVerifikasi: response.cek_verifikasi ? 1 : 0,
            employee_uuids: response.employee_uuids
              ? response.employee_uuids
              : [],
            position_uuids: response.position_uuids
              ? response.position_uuids
              : [],
          });
          setTimeout(() => {
            this.setState({
              configPenilaian:
                this.state.configValue == 0
                  ? 1
                  : (this.state.configStartDateEselon &&
                      this.state.configEndDateEselon) ||
                    (this.state.configStartDateAdmin &&
                      this.state.configEndDateAdmin)
                  ? this.checkCurrentMonth()
                  : 0,
            });
          }, 500);

          // setTimeout(() => {
          this.setState({
            is_eselon: this.getEselon(),
            positionSelected: this.getPosition(),
          });
          // }, 500);
          // console.log("local : " + localStorage.getItem("currentPositionUuid"));
          // console.log("state : " + this.state.positionSelected);
          setTimeout(() => {
            this.setState({
              is_eselon: this.getEselon(),
              positionSelected: this.getPosition(),
            });
          }, 1000);
          // console.log("positionSelected : " + this.state.positionSelected);
          setTimeout(() => {
            // this.activeRef.current.setTokenAPI();
            // this.secondRef.current.setTokenAPI();
          }, 2000);

          // this.setState({
          //   is_eselon: this.getEselon(),
          //   positionSelected: this.getPosition(),
          // });

          // console.log("configValue : " + this.state.configValue);
          // console.log("configPenilaian : " + this.state.configPenilaian);
          // console.log("is_eselon : " + this.state.is_eselon);
          // console.log("statusVerifikasi : " + this.state.statusVerifikasi);

          // this.activeRef.current.setTokenAPI();
          // this.secondRef.current.setTokenAPI();

          // setTimeout(() => {
          //   this.activeRef.current.setTokenAPI();
          //   this.secondRef.current.setTokenAPI();
          // }, 2000);
          // // if (this.state.loadingTableAtasan == false) {
          //   setTimeout(() => {
          //     this.setState({
          //       is_eselon: this.getEselon(),
          //       positionSelected: this.getPosition(),
          //     });
          //   }, 1000);
          //   setTimeout(() => {
          //     this.activeRef.current.setTokenAPI();
          //     this.secondRef.current.setTokenAPI();
          //   }, 2000);
          // }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              workUnitOptions: reformatWorkUnit(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.listAtasanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingTableAtasan: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            // let add_filter = {
            //   echelon_code: null,
            //   employee_name: null,
            //   first_echelon_code: null,
            //   hirarki: null,
            //   position_name: "Semua Data",
            //   position_uuid: null,
            // };
            // response.result.unshift(add_filter);
            // console.log(response);

            this.setState({
              atasanOptions: reformatAtasan(response.result),
              totalEselon: response.total_eselon,
              loadingTableAtasan: false,
            });
            this.setState({
              positionSelected:
                response.result > 0 ? response.result[0].position_uuid : "",
            });

            this.detailBobot();
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    // this.dataTableBloc.generateChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.LOADING:
    //       break;
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         this.setState({
    //           loading: false,
    //         });
    //         this.activeRef.current.setTokenAPI();
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    // this.dataTableBloc.verifikasiChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.LOADING:
    //       break;
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         this.setState({
    //           loading: false,
    //         });
    //         this.activeRef.current.setTokenAPI();
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    this.dataTableBloc.sendNotificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              loading: false,
              success: true,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.listAtasan();
    // this.detailBobot();
    // this.dataTableBloc.fetchWorkUnit({ status: 1 });
  }

  componentWillUnmount() {
    this.createBloc.listAtasanChannel?.unsubscribe();
    this.dataTableBloc.detailBobotChannel?.unsubscribe();
    this.dataTableBloc.workUnitChannel?.unsubscribe();
    this.createBloc.createChannel?.unsubscribe();
    // this.dataTableBloc.generateChannel?.unsubscribe();
    // this.dataTableBloc.verifikasiChannel?.unsubscribe();
    this.dataTableBloc.sendNotificationChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Daftar Laporan Penilaian Pegawai</CardTitle>
                  <CardSubtitle className="mb-3">
                    Kelola Daftar Laporan Penilaian Pegawai
                  </CardSubtitle>
                  <hr />

                  {/* Start of : Menu Filter Untuk Pegawai Eselon 1 & 2, Pegawai Definiti non eselon tapi punya jabtan plt eselon 1 & 2 ||  dan Administrator  */}

                  {/* {this.state.loadingTable} */}

                  {this.state.loadingTableAtasan == false &&
                  ((this.state.roleId == 2 && this.state.is_eselon == 1) ||
                    (this.state.roleId == 2 &&
                      this.state.is_eselon == 0 &&
                      this.state.totalEselon > 0) ||
                    this.state.roleId == 1) ? (
                    <>
                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Pembayaran{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => {
                              this.setState({ month: v.value });
                              this.handleperiodePenilaian(
                                v.value,
                                this.state.year
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>

                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => {
                              this.setState({ year: v.value });
                              this.handleperiodePenilaian(
                                this.state.month,
                                v.value
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3" style={{ display: "none" }}>
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Penilaian{" "}
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.monthPenilaian}
                            onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                          />
                        </Col>

                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.yearPenilaian}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Atasan Langsung <span className="text-danger">*</span>
                        </label>
                        <Col md="10">
                          <CustomSelect
                            // isLoading={true}
                            name="work_unit_hirarki"
                            errorMessage="Pilih Atasan"
                            options={this.state.atasanOptions}
                            placeholder="Pilih Atasan"
                            defaultValue={
                              this.state.roleId == 2
                                ? localStorage.getItem("currenPositionUuid")
                                  ? localStorage.getItem("currenPositionUuid")
                                  : this.state.positionSelected
                                : this.state.positionSelected
                            }
                            onChange={(v) => {
                              // if (this.state.roleId == 2) {
                              localStorage.setItem(
                                "currentEchelonCode",
                                JSON.stringify(v.model.echelon_code)
                              );
                              localStorage.setItem(
                                "currentPositionUuid",
                                JSON.stringify(v.model.position_uuid)
                              );
                              localStorage.setItem(
                                "currentPositionName",
                                JSON.stringify(v.model.position_name)
                              );

                              // kondisi kalau misalkan pilih semua data atasan
                              if (v.model.employee_uuid) {
                                localStorage.setItem(
                                  "currentEmployeeUuid",
                                  JSON.stringify(v.model.employee_uuid)
                                );
                              } else {
                                localStorage.removeItem("currentEmployeeUuid");
                              }

                              // }
                              this.setState({
                                atasanSelected: v.model.employee_uuid,
                                positionSelected: v.value,
                              });
                            }}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>
                    </>
                  ) : this.state.loadingTableAtasan == false &&
                    this.state.totalEselon == 0 &&
                    this.state.is_eselon == 0 &&
                    this.state.roleId == 2 ? (
                    <>
                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Pembayaran{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => {
                              this.setState({ month: v.value });
                              this.handleperiodePenilaian(
                                v.value,
                                this.state.year
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => {
                              this.setState({ year: v.value });
                              this.handleperiodePenilaian(
                                this.state.month,
                                v.value
                              );
                            }}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3" style={{ display: "none" }}>
                        <label
                          htmlFor="no_skx"
                          className="col-md-2 col-form-label"
                        >
                          Periode Penilaian{" "}
                        </label>
                        <Col md="2">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.monthPenilaian}
                            onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                          />
                        </Col>

                        <Col md="2">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.yearPenilaian}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Nama
                        </label>
                        <Col md="2">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_full_name}
                          </label>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          NIP
                        </label>
                        <Col md="2">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_nip}
                          </label>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label
                          htmlFor="work_unit_hirarki"
                          className="col-md-2 col-form-label"
                        >
                          Jabatan
                        </label>
                        <Col md="6">
                          <label
                            htmlFor="work_unit_hirarki"
                            className="col-form-label"
                          >
                            {this.userdata.employee_current_position_name}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row className="mb-3">
                        <Col md="2">
                          <Shimmer>
                            <div
                              style={{
                                width: "100%",
                                height: 30,
                                marginBottom: "10px",
                              }}
                            ></div>
                          </Shimmer>
                        </Col>
                        <Col md="2">
                          <Shimmer>
                            <div
                              style={{
                                width: "100%",
                                height: 30,
                                marginBottom: "10px",
                              }}
                            ></div>
                          </Shimmer>
                        </Col>

                        <Col md="2">
                          <Shimmer>
                            <div
                              style={{
                                width: "100%",
                                height: 30,
                                marginBottom: "10px",
                              }}
                            ></div>
                          </Shimmer>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md="2">
                          <Shimmer>
                            <div
                              style={{
                                width: "100%",
                                height: 30,
                                marginBottom: "10px",
                              }}
                            ></div>
                          </Shimmer>
                        </Col>
                        <Col md="10">
                          <Shimmer>
                            <div
                              style={{
                                width: "100%",
                                height: 30,
                                marginBottom: "10px",
                              }}
                            ></div>
                          </Shimmer>
                        </Col>
                      </Row>
                    </>
                  )}
                  {/* End  of : Menu Filter Untuk Eselon 1 & 2 dan Administrator  */}

                  <Row className="mb-3">
                    <label
                      htmlFor="no_skx"
                      className="col-md-2 col-form-label"
                    ></label>
                    <Col md="9">
                      <Alert color="info" role="alert">
                        <b>
                          <i className="uil uil-exclamation-triangle me-2"></i>{" "}
                          Tanggal Penilaian :
                        </b>
                        <ul className="m-0" style={{ paddingLeft: "0.75rem" }}>
                          <li>
                            Presensi :{" "}
                            <strong>
                              {/* yang digunakan pada tanggal{" "} */}
                              {this.formatDate(
                                this.state.yearPresensi +
                                  "-" +
                                  this.state.monthPresensi +
                                  "-01"
                              )}
                            </strong>{" "}
                            s/d{" "}
                            <strong>
                              {this.formatDate(
                                this.state.yearPresensi +
                                  "-" +
                                  this.state.monthPresensi +
                                  "-" +
                                  this.getMaxDaysInMonth(
                                    this.state.monthPresensi,
                                    this.state.yearPresensi
                                  )
                              )}{" "}
                            </strong>
                          </li>
                          <li>
                            SKP :{" "}
                            <strong>
                              {/* Maksimal dilakukan pada tanggal{" "} */}
                              {this.formatDate(
                                this.state.yearPenilaian +
                                  "-" +
                                  this.state.monthPenilaian +
                                  "-01"
                              )}
                            </strong>{" "}
                            s/d{" "}
                            <strong>
                              {this.formatDate(
                                this.state.yearPenilaian +
                                  "-" +
                                  this.state.monthPenilaian +
                                  "-" +
                                  this.getMaxDaysInMonth(
                                    this.state.monthPenilaian,
                                    this.state.yearPenilaian
                                  )
                              )}{" "}
                              {/* {"   "}
                              {this.state.configPenilaian == 1 ? (
                                <Badge className="rounded-pill bg-success font-size-12">
                                  Masih bisa melakukan Penilaian Kinerja
                                  Individu
                                </Badge>
                              ) : (
                                <Badge className="rounded-pill bg-danger font-size-12">
                                  Tidak bisa melakukan Penilaian Kinerja
                                  Individu
                                </Badge>
                              )} */}
                            </strong>
                          </li>
                          <li>
                            Ekspektasi Pimpinan :{" "}
                            <strong>
                              {/* Maksimal dilakukan pada tanggal{" "} */}
                              {this.formatDate(
                                this.state.yearPenilaian +
                                  "-" +
                                  this.state.monthPenilaian +
                                  "-01"
                              )}
                            </strong>{" "}
                            s/d{" "}
                            <strong>
                              {this.formatDate(
                                this.state.yearPenilaian +
                                  "-" +
                                  this.state.monthPenilaian +
                                  "-" +
                                  this.getMaxDaysInMonth(
                                    this.state.monthPenilaian,
                                    this.state.yearPenilaian
                                  )
                              )}
                              {/* {"   "}
                              {this.state.configPenilaian == 1 ? (
                                <Badge className="rounded-pill bg-success font-size-12">
                                  Masih bisa melakukan penilaian
                                </Badge>
                              ) : (
                                <Badge className="rounded-pill bg-danger font-size-12">
                                  Tidak bisa melakukan penilaian
                                </Badge>
                              )} */}
                            </strong>
                          </li>
                          {/* <li>
                            Konfigurasi Penilaian :{" "}
                            {this.state.originalconfigPenilaian == 0 ? (
                              <Badge className="rounded-pill bg-danger font-size-12">
                                Dibuka pada tanggal 1 - 10, 2 bulan sebelum
                                periode pembayaran
                              </Badge>
                            ) : (
                              <Badge className="rounded-pill bg-success font-size-12">
                                Dibuka untuk kapanpun
                              </Badge>
                            )}
                          </li> */}

                          {/* <li>
                            Konfigurasi Notifikasi :{" "}
                            <strong>
                              {this.state.configNotif ? (
                                <>
                                  dilakukan reminder pada setiap tanggal{" "}
                                  {this.state.configNotif
                                    ? this.state.configNotif
                                    : null}
                                </>
                              ) : (
                                <>tidak ada reminder</>
                              )}
                            </strong>
                          </li> */}
                        </ul>
                      </Alert>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="2"></Col>
                    <Col md="10">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                          // if (this.state.roleId == 2) {
                          //   const echelon = JSON.parse(
                          //     localStorage.getItem("currentEchelonCode")
                          //   );
                          //   this.setState({
                          //     is_eselon:
                          //       echelon &&
                          //       typeof echelon === "string" &&
                          //       (echelon.startsWith("1") ||
                          //         echelon.startsWith("2"))
                          //         ? 1
                          //         : 0,
                          //   });

                          //   this.setState({
                          //     is_eselon: this.getEselon(),

                          //   });
                          // }
                          this.listAtasan();
                          // this.detailBobot();
                          // pake set time out karena aneh ga ke update is_eselon nya
                        }}
                      >
                        <i className="uil-search-alt"></i> Cari
                      </Button>{" "}
                      {this.state.roleId == 1 ? (
                        <>
                          <Button
                            color="warning"
                            type="button"
                            onClick={() => {
                              this.handleButtonReset();
                            }}
                          >
                            <i className="uil-refresh"></i> Reset
                          </Button>{" "}
                          <Button
                            color="warning"
                            type="button"
                            onClick={() => {
                              this.handleButtonExport();
                            }}
                          >
                            <i className="uil-file-download"></i> Export Xls
                          </Button>{" "}
                          <Button
                            color="success"
                            type="button"
                            onClick={() => {
                              this.setState({
                                confirm: true,
                                runType: 4,
                                confirmInfo:
                                  "Apakah anda yakin akan melakukan Kirim Notifikasi ke atasan yang belum melakukan Penilaian Ekpektasi Pimpinan ?",
                              });
                            }}
                            // this.handleSendNotification();
                            disabled={
                              this.state.statusVerifikasi == 1 ? true : false
                            }
                          >
                            <i className="uil-fast-mail"></i> Kirim Notifikasi
                            Atasan
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                      {/* End of : Tombol Upload E-Kinerja, Generate, Verifikasi, Export untuk Administrator */}
                    </Col>
                  </Row>

                  <hr />
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          {this.state.is_eselon == 1 || this.state.roleId == 1
                            ? "Penilaian Bawahan"
                            : " Penilaian Diri Sendiri"}
                        </span>
                      </NavLink>
                    </NavItem>

                    <NavItem
                      style={{
                        display:
                          this.state.is_eselon == 1 && this.state.roleId == 2
                            ? "block"
                            : "none",
                      }}
                    >
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-envelope"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Penilaian Diri Sendiri
                        </span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent
                    activeTab={this.state.activeTab}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      {this.state.loadingTableAtasan == false &&
                      this.state.loadingDetail == false ? (
                        <>
                          <TablePenilaianBawahanComponent
                            ref={this.activeRef}
                            // onConfigChange={this.handleConfigChange}
                            // is_eselon={this.state.is_eselon}
                            setDocument={(doc) =>
                              this.setState({ document: doc })
                            }
                            loading={{
                              loadingTableAtasan: this.state.loadingTableAtasan,
                              loadingDetail: this.state.loadingDetail,
                            }}
                            additionalFilter={{
                              year: this.state.year,
                              month: this.state.month,
                              workunit: this.state.workUnitSelected,
                              employee_uuid: this.state.atasanSelected,
                              presensi: this.state.presensi,
                              skp: this.state.skp,
                              penilaian: this.state.penilaian,
                              yearFilter: this.state.yearFilter,
                              monthFilter: this.state.monthFilter,
                              configPenilaian: this.state.configPenilaian,
                              configStartDateEselon:
                                this.state.configStartDateEselon,
                              configEndDateEselon:
                                this.state.configEndDateEselon,
                              configStartDateAdmin:
                                this.state.configStartDateAdmin,
                              configEndDateAdmin: this.state.configEndDateAdmin,
                              statusVerifikasi: this.state.statusVerifikasi,
                              employee_uuids: this.state.employee_uuids,
                              position_uuids: this.state.position_uuids,
                              position_uuid: this.state.positionSelectedSend,
                              is_eselon: this.state.is_eselon,
                            }}
                          />
                        </>
                      ) : (
                        <div
                          className="md-12 text-center"
                          style={{
                            alignItems: "center",
                            left: "50%",
                          }}
                        >
                          <Spinner className="text-center" color="primary" />
                          <div>Memuat Data</div>
                        </div>
                      )}
                    </TabPane>
                    <TabPane tabId="2">
                      {this.state.loadingTableAtasan == false &&
                      this.state.loadingDetail == false ? (
                        <>
                          <TablePenilaianDiriSendiriComponent
                            ref={this.secondRef}
                            setDocument={(doc) =>
                              this.setState({ document: doc })
                            }
                            additionalFilter={{
                              year: this.state.year,
                              month: this.state.month,
                              workunit: this.state.workUnitSelected,
                              employee_uuid: this.state.atasanSelected,
                              presensi: this.state.presensi,
                              skp: this.state.skp,
                              penilaian: this.state.penilaian,
                              yearFilter: this.state.yearFilter,
                              monthFilter: this.state.monthFilter,
                              configPenilaian: this.state.configPenilaian,
                              configStartDateEselon:
                                this.state.configStartDateEselon,
                              configEndDateEselon:
                                this.state.configEndDateEselon,
                              configStartDateAdmin:
                                this.state.configStartDateAdmin,
                              configEndDateAdmin: this.state.configEndDateAdmin,
                              statusVerifikasi: this.state.statusVerifikasi,
                              employee_uuids: this.state.employee_uuids,
                            }}
                          />
                        </>
                      ) : (
                        <div
                          className="md-12 text-center"
                          style={{
                            alignItems: "center",
                            left: "50%",
                          }}
                        >
                          <Spinner className="text-center" color="primary" />
                          <div>Memuat Data</div>
                        </div>
                      )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil disimpan"
            failedTitle="Gagal!"
            failedInfo="Data gagal disimpan"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
          <Modal size={"lg"} isOpen={this.state.showUpload}>
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myLargeModalLabel">
                Upload Data E-Kinerja
              </h5>
              <button
                onClick={() => {
                  this.setState({
                    showUpload: false,
                  });
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <div className="modal-body">
                <a
                  href={
                    process.env.REACT_APP_SERVICE_CORE_URL +
                    "/templates/Template_SKP.xlsx"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Unduh template...
                </a>
                <br />
                <br />
                <FileInput
                  name="special_allowance_summary_doc"
                  validate={{ required: { value: false } }}
                  maxFiles={1}
                />
              </div>
              <div className="modal-footer">
                {this.state.document && (
                  <a
                    href={this.state.document?.documents_path}
                    target="_blank"
                    className="me-auto"
                  >
                    Download Document Sebelum nya
                  </a>
                )}
                <Button
                  color="success"
                  type="submit"
                  onClick={() => {
                    this.setState({
                      confirm: true,
                      runType: 1,
                      confirmInfo:
                        "Apakah anda yakin akan melakukan Upload Data E-Kinerja?",
                    });
                  }}
                >
                  Simpan Data
                </Button>{" "}
                <Button
                  color="danger"
                  onClick={() => {
                    this.setState({
                      showUpload: false,
                    });
                  }}
                >
                  Cancel
                </Button>
              </div>
            </AvForm>
          </Modal>
        </Container>
      </Fragment>
    );
  }
}

export default IndexView;
